import { DialogTitleWrapper } from "../../wrapper";
import { styled } from "@mui/material/styles";

export const DialogTitleStyle = styled(DialogTitleWrapper)(() => ({
    cursor: 'move'
}))